(function(){
    'use strict';
    var stickyAnchor = false;
    var stickyAnchorLastScrollTop = 0;

    function isMobile() {
        
       return window.getComputedStyle(document.body).zIndex === "1";
    }

    function generateAnchorLinks() {
        if($('.bq__ct__anchor-links').length > 0) {
            if($('.bq__ct__anchor-links__anchor-point').length > 0 && $('.bq__ct__anchor-links__item').length <= 0) {




                $('.bq__ct__anchor-links__anchor-point').each(function() {
                    var $this = $(this);
                    var anchorId = $this.text().toLowerCase().split(' ').join('_');
                    var anchorLink = `
                        <li class="bq__ct__anchor-links__item" data_anchorid="${anchorId}">
                        <div class="bq__ct__anchor-links__item__link__number"></div>
                            <a href="#${anchorId}" class="bq__ct__anchor-links__item__link">
                                ${$this.text()}
                                <i class="fal fa-long-arrow-down bq__ct__anchor-links__item__icon"></i>
                            </a>
                        </li>
                    `;

                    $this.attr('id', anchorId);
                    $('.bq__ct__anchor-links nav .bq__ct__anchor-links__items').append(anchorLink);
                });
            } else {
                if($('.bq__ct__anchor-links__item').length <= 0) {
                    $('.bq__ct__anchor-links nav .bq__ct__anchor-links__items').append("<li>No anchor points found. Please either add an anchor point manually or a Timeline Scroller Step.</li>");
                }
            }
        }
        
       
    }

    function triggerBackToTop(enabled) {
        if(enabled) {
            if($('.bq__ct__anchor-links__back-to-top').length > 0) {
                $('.bq__ct__anchor-links__back-to-top').addClass('stuck');
            }
        } else {
            if($('.bq__ct__anchor-links__back-to-top').length > 0) {
                $('.bq__ct__anchor-links__back-to-top').removeClass('stuck');
            }
        }
    }

    function addStickyAnchorLinks() {        
        if($('.bq__ct__anchor-links__container--sticky').length > 0) {
            $('.bq__ct__anchor-links__sticky-anchor').innerHeight($('.bq__ct__anchor-links__container').outerHeight(true) );
            $('.bq__ct__anchor-links__container--sticky').addClass('stuck');
        }
    }

    function removeStickyAnchorLinks() {
        if($('.bq__ct__anchor-links__container--sticky').length > 0) {
            $('.bq__ct__anchor-links__sticky-anchor').innerHeight(0);
            $('.bq__ct__anchor-links__container--sticky').removeClass('stuck');
        }
    }

    function updateStickyAnchorLinks(scrollingDown) {
        var top = $(window).scrollTop();
        var anchor = $('.bq__ct__anchor-links__sticky-anchor').offset().top - $('.bq__ct__anchor-links__container').innerHeight() - 40;
        var bottomAnchor = $('.bq__ct__anchor-links__sticky-anchor').offset().top - 22;

        if(!isMobile()) {
            if(scrollingDown) {
                if (top > anchor) {
                    if(!stickyAnchor) {
                        addStickyAnchorLinks(); 
                    }

                    if($('.bq__ct__anchor-links__container--sticky').length > 0) {
                        triggerBackToTop(false);
                    } else {
                        triggerBackToTop(true); 
                    }  
                    
                    stickyAnchor = true;
                }
            } else {
                if((top < bottomAnchor) && stickyAnchor) {
                    removeStickyAnchorLinks();
                    triggerBackToTop(false);
                    stickyAnchor = false;
                }
            }
        } else {
            $('.bq__ct__anchor-links__item').removeClass('active');
            removeStickyAnchorLinks();
            if (top > anchor) {
                triggerBackToTop(true);
            } else {
                triggerBackToTop(false);
            }
        }
    }

    function triggerStickyAnchorLinks() {
        var $stickyNav = $('.bq__ct__anchor-links__container--sticky');
        var $anchorLinks = $('.bq__ct__anchor-links__item__link');
        var currentScroll = $(this).scrollTop();
        if (currentScroll > stickyAnchorLastScrollTop){
            updateStickyAnchorLinks(true);
        } else {
            updateStickyAnchorLinks(false);
        }

        if ($anchorLinks.length && $stickyNav.length && $stickyNav.hasClass('stuck')) {
            $('.bq__ct__anchor-links__item__link').each(function() {
                var $this = $(this);
                var stickyTop = $stickyNav.offset().top;
                var stickyHeight = $stickyNav.height();
                var $relatedAnchorPoint = $(`#${$this.attr('href').replace('#','')}`);
                var relatedAnchorPointTop;

                if($relatedAnchorPoint.length > 0) {
                    relatedAnchorPointTop = $relatedAnchorPoint.offset().top;
                    if(stickyTop + stickyHeight > relatedAnchorPointTop - 50) {
                        $this.closest('.bq__ct__anchor-links__item').addClass('is-passed')
                        $this.find('.fa-long-arrow-down').removeClass('fa-long-arrow-down').addClass('fa-long-arrow-up');
                    } else {
                        $this.closest('.bq__ct__anchor-links__item').removeClass('is-passed')
                        $this.find('.fa-long-arrow-up').removeClass('fa-long-arrow-up').addClass('fa-long-arrow-down');
                    }
                }
            });

            //only set these when we are not on a timeline page / guide and we are not scrolling from the nav
            if ($('.bq_timeline-guide').length === 0 && $('.bq_timeline_page').length === 0 && squiz.vars.scrollingFromNavClick !== true){
                $('.bq__ct__anchor-links__item').removeClass('active').filter('.is-passed').last().addClass('active');                
            }
        }

        stickyAnchorLastScrollTop = currentScroll;
    }

    function scrollToAnchorLink($target) {
        var $linksContainer = $('.bq__ct__anchor-links__container');
        var $timelineStep = $('.bq__ct__timeline-step');
        var offset = parseInt($target.css('margin-top'), 10);
        if ($linksContainer.hasClass('stuck')) {
            if($timelineStep.length > 0) {
                $('html').animate({
                    scrollTop: $target.offset().top - $linksContainer.height() - offset
                }, 400, window.squiz.fn.setScrollingFromNavComplete);
            } else {
                $('html').animate({
                    scrollTop: $target.offset().top - $linksContainer.height() - offset - 15
                }, 400, window.squiz.fn.setScrollingFromNavComplete);
            }
        } else {
            var $cloneLinksContainer = $linksContainer
                .clone()
                .addClass('stuck')
                .css({display: 'block', visibility: 'hidden'})
                .insertAfter($linksContainer);
            var stuckHeight = $cloneLinksContainer.height();
            $cloneLinksContainer.remove();

            if($timelineStep.length > 0) {
                $("html").animate({
                    scrollTop: $target.offset().top - stuckHeight - offset
                }, window.squiz.fn.setScrollingFromNavComplete);
            } else {
                $("html").animate({
                    scrollTop: $target.offset().top - stuckHeight - offset - 15
                }, window.squiz.fn.setScrollingFromNavComplete);
            }
        }
    }

    $(document).on('click', '.bq__ct__anchor-links a[href^="#"]', function (e) {
        e.preventDefault();

        
        

        var $target = $($.attr(this, 'href'));

        if ($target.length === 0) {
            return;
        }

        // Scrolls to the anchor point found with the same ID.
        if(isMobile()) {
            window.squiz.fn.setScrollingFromNav();
            $('html').animate({
                scrollTop: $target.offset().top - 15
            }, 400, window.squiz.fn.setScrollingFromNavComplete);

        } else {
            $('.bq__ct__anchor-links__item').removeClass('active');
        var parentLI = this.closest('.bq__ct__anchor-links__item');
        $(parentLI).addClass('active'); 

            window.squiz.fn.setScrollingFromNav();
           
            if($('.bq__ct__anchor-links__container--sticky').length > 0) {
                scrollToAnchorLink($target);
            } else {
                $('html').animate({
                    scrollTop: $target.offset().top - 15
                }, 400, window.squiz.fn.setScrollingFromNavComplete); 
            }
        }
    });

    function initStickyHeaderSpacer(){
        var top = $(window).scrollTop();
        var anchor = $('.bq__ct__anchor-links__sticky-anchor').offset().top - $('.bq__ct__anchor-links__container').innerHeight() - 40;
        
        if(!isMobile()) {
            if (top > anchor) {
                //if(!stickyAnchor) {
                    addStickyAnchorLinks(); 
               // }
            }
            
        }
    }

    $(document).on('click', '.bq__ct__anchor-links__back-to-top__btn', function (e) {
        e.preventDefault();
        var anchor = $('.bq__ct__anchor-links__sticky-anchor').offset().top - $('.bq__ct__anchor-links__container').height() - 20;

        // Scrolls back up to the anchor links initial starting point
        $('html, body').animate({
            scrollTop: anchor
        }, 500);
    });

    if($('.bq__ct__anchor-links__container').length > 0) {
        triggerStickyAnchorLinks();
        
        $(window).on('scroll', triggerStickyAnchorLinks);
        $(window).on('resize', updateStickyAnchorLinks(true));
        //this adds the spacer when 
        setTimeout(function(){
            initStickyHeaderSpacer();
            
        },250)
    }

    if($('.bq__ct__anchor-links').length > 0) {
        generateAnchorLinks();
    }

    if($('.bq__ct__anchor-links__container--sticky').length > 0) {
        $(document).on('click', 'a[href^="#"]', function (e) {
            var $target = $($.attr(this, 'href'));
            if(isMobile()) {
                $('html, body').animate({
                    scrollTop: $target.offset().top - 15
                }, 400);
            } else {
                scrollToAnchorLink($target);
            }
        });
    }
}());
